import axios from "axios";
import { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom"; // Correctly imported useParams
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../components/layout/Layout";
import { formatDate } from "../../helpers/DateConversion";

export default function ViewDriverWallet() {
    const location = useLocation();
    const data = location.state?.data;
    const navigate = useNavigate();
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [walletData, setWalletData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [paymentAmount, setPaymentAmount] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [wallet, setWallet] = useState(0);

    const getUsers = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("sansadToken");
            const headers = {
                authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            };
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/admin/view-driver-wallets?status=Active&page=${currentPage}&driverId=${id}&limit=${recordsPerPage}`,
                {
                    headers: headers,
                }
            );
            if (response.data.statusCode === 200) {
                setWalletData(response.data.result.users);
                setWallet(response.data.result.wallet)
                setTotalPages(response.data.result.totalPages);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    };

    useEffect(() => {
        getUsers();
    }, [currentPage, recordsPerPage, id]);

    const handlePayment = async () => {

        if (wallet < paymentAmount) {
            alert("Pay amount can not be greater than wallet balance");
            return;
        }

        setLoading(true);
        try {

            const token = localStorage.getItem("sansadToken");
            const headers = {
                authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            };
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/admin/pay-driver`,
                { driverId: id, amount: paymentAmount },
                { headers: headers }
            );
            if (response.data.statusCode === 200) {
                toast.success("Payment Successful");
                getUsers();
                setShowModal(false);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error(error);
            toast.error("Payment failed");
        }
        setLoading(false);
    };

    return (
        <Layout>
            <ToastContainer />
            <div className="bg-white md:p-10 p-4 rounded-xl shadow-md mt-8">
                <div className="flex justify-between items-center">
                    <div className="flex items-center">
                        <h2 className="text-xl font-medium">View Driver Wallet</h2>
                        <p className="ml-4">Wallet Balance : {wallet}</p>
                    </div>
                    <div className="flex space-x-2">
                        <button
                            className="border px-4 py-2 rounded-md text-sm"
                            onClick={() => setShowModal(true)}
                        >
                            Manage Wallet
                        </button>
                        <button
                            onClick={() => navigate(-1)}
                            className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
                        >
                            Back
                        </button>
                    </div>
                </div>

                <div className="mt-8 overflow-x-auto">
                    <table className="table-auto w-full text-sm border-collapse">
                        <thead>
                            <tr>
                                <th className="px-4 py-2 border">S. No.</th>
                                <th className="px-4 py-2 border">Type</th>
                                <th className="px-4 py-2 border">Amount</th>
                                <th className="px-4 py-2 border">Order ID</th>
                                <th className="px-4 py-2 border">Description</th>
                                <th className="px-4 py-2 border">Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {walletData?.length > 0 ? (
                                walletData.map((item, index) => (
                                    <tr key={item._id}>
                                        <td className="px-4 py-2 border">{index + 1}</td>
                                        <td className="px-4 py-2 border">{item.type || "N/A"}</td>
                                        <td className="px-4 py-2 border">{item.amount || "N/A"}</td>
                                        <td className="px-4 py-2 border">{item.orderId || "N/A"}</td>
                                        <td className="px-4 py-2 border">{item.description || "No description"}</td>
                                        <td className="px-4 py-2 border">{formatDate(item.createdAt)}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" className="px-4 py-2 text-center border">
                                        No records found
                                    </td>
                                </tr>
                            )}
                        </tbody>

                    </table>
                </div>

                {/* Pagination */}
                <div className="mt-4 flex justify-between items-center">
                    <button
                        onClick={() => setCurrentPage(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="px-4 py-2 bg-gray-300 rounded-md"
                    >
                        Prev
                    </button>
                    <span>
                        Page {currentPage} of {totalPages}
                    </span>
                    <button
                        onClick={() => setCurrentPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="px-4 py-2 bg-gray-300 rounded-md"
                    >
                        Next
                    </button>
                </div>
            </div>

            {/* Manage Wallet Modal */}
            {showModal && (
                <div className="fixed inset-0 flex justify-center items-center bg-gray-800 bg-opacity-50">
                    <div className="bg-white p-6 rounded-xl shadow-md w-96">
                        <h2 className="text-xl font-medium mb-4">Manage Wallet</h2>
                        <div className="mb-4">
                            <label htmlFor="amount" className="block text-sm font-medium">
                                Enter Amount to Pay
                            </label>
                            <input
                                type="number"
                                id="amount"
                                className="w-full p-2 border border-gray-300 rounded-md"
                                value={paymentAmount}
                                onChange={(e) => setPaymentAmount(e.target.value)}
                                placeholder="Enter Amount"
                                min={1}
                            />
                        </div>
                        <div className="flex justify-end">
                            <button
                                onClick={handlePayment}
                                className="px-4 py-2 bg-blue-500 text-white rounded-md"
                                disabled={loading}
                            >
                                {loading ? "Processing..." : "Pay Driver"}
                            </button>
                            <button
                                onClick={() => setShowModal(false)}
                                className="ml-2 px-4 py-2 bg-gray-300 rounded-md"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </Layout>
    );
}
